// extracted by mini-css-extract-plugin
export var animationContainer = "_he-0";
export var asteriskIcon = "_he-8";
export var conversationLeftSection = "_he-4";
export var conversationListItem = "_he-3";
export var conversationMiddleSection = "_he-5";
export var conversationRightSection = "_he-6";
export var detailsContent = "_he-1";
export var listContainer = "_he-7";
export var modalContent = "_he-2";